import React, { KeyboardEvent } from 'react';
import { Countdown } from '../Countdown/Countdown';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';
import { styles } from './CountDownSnackbar.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { useNavigate } from '../PlatformFunctionality';
import { ContentBlock } from '../ContentBlock';
import { SnackbarProps } from '../Contentful/transformers/SnackbarTransformer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export type CountDownSnackbarProps = SnackbarProps & {
  startDate?: Date;
  className?: string;
};

export const CountDownSnackbar = ({
  endDate,
  startDate,
  intro,
  content,
  url,
  backgroundColor = '#0099FF',
  textColor = '#000000',
  headingColor = '#FFFFFF',
  className,
}: CountDownSnackbarProps) => {
  const navigateTo = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!url) return;

    navigateTo(url);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if ([' ', 'Enter'].includes(e.key)) handleClick(e as unknown as React.MouseEvent);
  };

  return (
    <ContentBlock style={{ backgroundColor }}>
      <div
        tabIndex={0}
        role="button"
        onKeyDown={handleKeyDown}
        onClick={handleClick}
        className={classNames([
          styles.container({
            withCountdown: Boolean(endDate),
          }),
          className,
        ])}
      >
        {intro ? (
          <CrazyFont variant="withShadowAndOutline" className={styles.intro} style={{ color: headingColor }}>
            {intro}
          </CrazyFont>
        ) : null}
        {endDate ? (
          <div className={styles.countdown}>
            <Countdown endDate={endDate} startDate={startDate} />
          </div>
        ) : null}
        {content ? (
          <span style={{ color: textColor }} className={styles.text}>
            {documentToReactComponents(content)}
          </span>
        ) : null}
      </div>
    </ContentBlock>
  );
};
